import { matchRoutes, useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { connect } from 'react-redux';
import { Stack, Tabs, Tab, Typography, Box, IconButton } from '@mui/material';
import MasterComponent from '../../common/MasterComponent';
import { useTheme } from '@mui/material';
import { useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import AddEditTemplate from "./addEditTemplate";
import AddEditSecret from "./addEditSecret";
import { addSecretDefFields, addTemplateDefFields } from "./form";
import { ReactComponent as VrLine } from '../../assets/icons/main/verticalLine.svg';
import { ReactComponent as AssignIcon } from '../../assets/icons/main/verticalLine.svg';
import { ReactComponent as ViewIcon } from '../../assets/icons/main/view-icon.svg';
import { ReactComponent as AlertIcon } from '../../assets/icons/main/alertIcon.svg';
import { ReactComponent as CreateIcon } from '../../assets/icons/main/create-icon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/main/delete-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/main/close-icon.svg';
import SecretDetails from "./secretDetails";
import { useDispatch } from "react-redux";
import { secretManagerActions } from "../../store/reducers/secret-manager";
import { palette } from "../../theme/palette";
import PopUp from "../../components/Popup";
import dayjs from "dayjs";
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from "../../utils/table-utils";

import { ReactComponent as KeyboardArrowDownIcon } from '../../assets/icons/main/expand-down-icon.svg';
import { ReactComponent as KeyboardArrowUpIcon } from '../../assets/icons/main/collapse-up-icon.svg';

import { ReactComponent as VerticalLine } from '../../assets/icons/main/verticalLine.svg';

interface SecretFieldNameTypes {
    secret_name: string;
    created_date: string;
    template_id: any;
}

interface TemplateFieldNameTypes {
    template_name: string;
    created_date: string;
}

const SecretManger = ({ isSecretManagementDataLoading, secretsData, isAddSecretSuccess, isDeleteSecretSuccess, templateData, isAddTemplateSuccess, isUpdateTemplateSuccess, isDeleteTemplateSuccess, secretManagerDataPageNumber, secretManagerDataTotalRowCount, secretTemplateDataTotalRowCount, secretTemplateDataPageNumber, isUpdateSecretSuccess, decryptedSecret, userAccess, isFetchingSecretById }: any) => {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const themeData = useTheme();
    const { pathname } = useLocation();
    const routePaths: any = get(useOutletContext(), 'combinedRoutePaths', [])
    const matchedRoute = matchRoutes(routePaths, pathname);
    const hasAccessTo = get(userAccess, `${get(matchedRoute, '[0].route.endPointPath', '')}`, {});

    const [tabState, setTabState] = useState<any>('secrets');
    const [templateModal, setTemplateModal] = useState<boolean>(false);
    const [secretModal, setSecretModal] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [secretSelectedData, setSecretSelectedData] = useState<any>(addSecretDefFields);
    const [secretTagsData, setSecretTagsData] = useState<any>([]);
    const [confirmPopup, setConfirmPopup] = useState<boolean>(false);
    const [deleteSelection, setDeleteSelection] = useState<string>('');
    const [templateSelectedData, setTemplateSelectedData] = useState<any>(addTemplateDefFields);
    const [templateTagsData, setTemplateTagsData] = useState<any>([]);
    const [secretData, setSecretData] = useState<any>([]);
    const [secretTemplateData, setSecretTemplateData] = useState<any>([]);
    const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });
    const [readonly, setReadonly] = useState<boolean>(false);
    const [expandedRows, setExpandedRows] = useState<number[]>([]);

    const dispatchSecretListRequest = (payload: any) => {
        if (tabState === 'secrets') {
            dispatch(secretManagerActions.getSecretsRequest({ ...sortingModel, ...params, ...payload }));
        } else {
            dispatch(secretManagerActions.getSecretTemplateRequest({ ...sortingModel, ...params, ...payload }))
        }

    };

    const createComponent = (id: any, data: any) => {
        return <SecretDetails secret_id={id} secretKeyData={data} readSecrets={readSecrets} hideSecrets={hideSecrets} />
    }

    useEffect(() => {
        setTabState(get(params, 'selectedTab', 'secrets'));
    }, [params])

    const onTabChange = (e: any, value: any) => {
        setTabState(value)
        navigate(`/secrets-manager/${value}`)
    }

    useEffect(() => {
        const reqParams: any = { limit: 10, page: 1 }
        if (tabState === 'secrets') {
            dispatch(secretManagerActions.getSecretsRequest(reqParams))
            dispatch(secretManagerActions.getSecretTemplateRequest())
        } else {
            dispatch(secretManagerActions.getSecretTemplateRequest(reqParams))
        }
    }, [tabState])

    useEffect(() => {
        if (secretsData.length) {
            setSecretData(secretsData.map((item: any, index: any) => {
                let secretPairs: any = Object.keys(get(item, 'key_value_pairs', {})).map((key: any, id: any) => ({
                    key: key,
                    id: id++,
                    value: item.key_value_pairs[key],
                    showValue: false
                }))
                return { ...item, id: item.secret_id, accordianComponent: createComponent(item.secret_id, secretPairs), key_value_pairs: secretPairs }
            }))
        } else {
            setSecretData([])
        }
    }, [secretsData])

    const readSecrets = (secret_id: any) => {
        dispatch(secretManagerActions.fetchSecretByIdRequest(secret_id))
    }

    const hideSecrets = (secret_id: any) => {
        setSecretData(secretData.map((item: any) => {
            if (secret_id === item.secret_id) {
                return { ...item, id: item.secret_id, accordianComponent: createComponent(item.secret_id, item.key_value_pairs), key_value_pairs: item.key_value_pairs }
            } else {
                return { ...item }
            }

        }))
    }

    useEffect(() => {
        if (templateData.length) {
            setSecretTemplateData(templateData.map((item: any) => {
                let tempTags: any = item.template_keys.map((key: any, index: any) => ({ id: index + 1, key: key, value: "" }));
                return { ...item, template_tags: tempTags }
            }))

        } else {
            setSecretTemplateData([])
        }
    }, [templateData])

    useEffect(() => {


        if (isAddSecretSuccess || isAddTemplateSuccess || isDeleteTemplateSuccess || isUpdateTemplateSuccess || isUpdateSecretSuccess || isUpdateSecretSuccess || isDeleteSecretSuccess) {
            dispatchSecretListRequest({
                limit: DEFAULT_PAGE_SIZE,
                page: secretManagerDataPageNumber,
                ...sortingModel
            })
        }


    }, [isAddSecretSuccess, isDeleteSecretSuccess, isUpdateSecretSuccess, isAddTemplateSuccess, isDeleteTemplateSuccess, isUpdateTemplateSuccess])

    const handleRowSelection = () => { }

    const onTemplateModalOpen = () => {
        setTemplateModal(!templateModal);
    }

    const onSecretModalOpen = () => {
        setSecretModal(!secretModal);
    }

    const handlePopupActions = (e: any, val: any) => {
        if (val === 'add_edit_popup_secret') {
            setSecretModal(false);
            setReadonly(false)
            setIsEdit(false);
            setSecretSelectedData(addSecretDefFields);
            setSecretTagsData(secretSelectedData.key_value_pairs);

        } else if (val === 'add_edit_popup_temp') {
            setTemplateModal(false);
            setIsEdit(false);
            setReadonly(false)
            setTemplateSelectedData(addTemplateDefFields);
            setTemplateTagsData([]);
        }
    }

    const handleMultipleActions = (type: string, payload: any,) => {
        if (type === 'template_edit') {
            setIsEdit(true);
            setReadonly(false);
            setTemplateSelectedData(payload);
            setTemplateTagsData(payload?.template_tags);
            setTemplateModal(true);
        } else if (type === 'template_delete') {
            setDeleteSelection('Template')
            setTemplateSelectedData(payload);
            // setTemplateTagsData(payload);
            setTemplateModal(false);
            setConfirmPopup(true);
        } else if (type == 'template_view') {
            setTemplateSelectedData(payload);
            setTemplateTagsData(payload?.template_tags);
            setReadonly(true)
            setTemplateModal(true);
        } else if (type == 'secrets_delete') {
            setDeleteSelection('Secret')
            setReadonly(false)
            setConfirmPopup(true);
            setSecretSelectedData(payload);
        } else if (type == 'secrets_edit') {
            dispatch(secretManagerActions.fetchSecretByIdRequest(payload?.id))
            setReadonly(false)
            setIsEdit(true);
            setSecretModal(true);
        }
    };

    const handleActions = (data: any, type: any) => {
        if (type === 'confirm') {
            if (deleteSelection === 'Secret') {
                dispatch(secretManagerActions.deleteSecretRequest(secretSelectedData));
                setSecretSelectedData(addSecretDefFields);
            } else {
                dispatch(secretManagerActions.deleteSecretTemplateRequest(templateSelectedData));
                setTemplateSelectedData(addTemplateDefFields);
            }
            setConfirmPopup(false);
        } else if (type === 'warning') {
            setSecretSelectedData(addSecretDefFields);
            setConfirmPopup(false);
        }
    };

    const renderTemplateFormModal = () => (
        <AddEditTemplate
            isOpen={templateModal}
            templateSelectedData={templateSelectedData}
            templateTagsData={templateTagsData}
            setTemplateSelectedData={setTemplateSelectedData}
            setTemplateTagsData={setTemplateTagsData}
            isEdit={isEdit}
            templateData={templateData}
            readonly={readonly}
            closeModal={() => handlePopupActions({}, 'add_edit_popup_temp')}
            hasAccessTo={hasAccessTo}
        />
    );

    const renderSecretsFormModal = () => (
        <AddEditSecret
            isOpen={secretModal}
            secretSelectedData={secretSelectedData}
            secretTagsData={secretTagsData}
            secretData={secretData}
            setSecretSelectedData={setSecretSelectedData}
            setSecretTagsData={setSecretTagsData}
            isEdit={isEdit}
            templateData={secretTemplateData}
            closeModal={() => handlePopupActions({}, 'add_edit_popup_secret')}
            hasAccessTo={hasAccessTo}
            loadingSecrets={isFetchingSecretById}
        />
    );

    useEffect(() => {
        if (!isEmpty(decryptedSecret)) {
            if (isEdit) {
                const _decryptedSecretKeyPairs = Object.keys(get(decryptedSecret, 'key_value_pairs', {})).map((key: any, id: any) => ({
                    key: key,
                    id: id++,
                    value: decryptedSecret.key_value_pairs[key],
                    showValue: false
                }))
                setSecretSelectedData({ ...decryptedSecret, key_value_pairs: _decryptedSecretKeyPairs });
            } else {
                setSecretData(secretData.map((item: any) => {
                    if (decryptedSecret.secret_id === item.secret_id) {
                        const _decryptedSecretKeyPairs = Object.keys(get(decryptedSecret, 'key_value_pairs', {})).map((key: any, id: any) => ({
                            key: key,
                            id: id++,
                            value: decryptedSecret.key_value_pairs[key],
                            showValue: true
                        }))
                        return { ...item, id: item.secret_id, accordianComponent: createComponent(item.secret_id, _decryptedSecretKeyPairs) }
                    } else {
                        return { ...item, id: item.secret_id, accordianComponent: createComponent(item.secret_id, item.key_value_pairs), key_value_pairs: item.key_value_pairs }
                    }

                }))
            }
        }
    }, [decryptedSecret])

    const secretColumns: any = [
        {
            field: 'secret_name',
            headerName: 'Secret Name',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 400,
            width: '400px',
            renderCell: (params: any) => {
                return (
                    <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                    >
                        {params.value}
                    </Typography>
                );
            },
        },
        {
            field: 'template_id',
            headerName: 'Secret Template',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 400,
            width: '400px',
            renderCell: (params: any) => {
                return (
                    <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                    >
                        {params.value > 0 ? templateData.find((item: any) => item.template_id === params.value)?.template_name : 'NA'}
                    </Typography>
                );
            },
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 400,
            width: '400px',
            renderCell: (params: any) => {
                return (
                    <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                    >
                        {/* {params.value} */}
                        {dayjs.utc(params.value).local().format('MMM D, YYYY')}
                    </Typography>
                );
            },
        },
        {
            field: 'actions',
            headerName: 'ACTIONS',
            sortable: false,
            headerAlign: 'center',
            align: 'center',
            customFilterReq: false,
            minWidth: 100,
            width: '100px',
            renderCell: (params: any) => {
                const disableUpdate = !hasAccessTo.update;
                const disableDelete = !hasAccessTo.delete;
                return (
                    <Box sx={{
                        display: 'flex',
                        gap: '16px', justifyContent: 'flex-end'
                    }}>
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => {
                            handleMultipleActions('secrets_edit', params.row)
                        }} disabled={disableUpdate}>
                            <CreateIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableUpdate ? 0.5 : 1,
                                }}
                            />
                        </IconButton>
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => handleMultipleActions('secrets_delete', params.row)} disabled={disableDelete}>
                            <DeleteIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableDelete ? 0.5 : 1,
                                }}
                            />
                        </IconButton>
                        <VerticalLine style={{ color: '#D9DFED' }} />
                        <IconButton onClick={() => handleExpandClick(params.row.id)} sx={{ padding: 0, margin: 0 }}>
                            {expandedRows.includes(params.row.id) ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </Box>

                );
            },
        },
        // {
        //     field: 'is_expanded',
        //     headerName: '',
        //     flex: 1,
        //     sortable: false,
        //     resizable: false,
        //     customFilterReq: false,
        //     headerAlign: 'center',
        //     align: 'center',
        //     minWidth: 20,
        //     width: '20px',
        // }
    ];

    const handleExpandClick = (id: number) => {
        hideSecrets(expandedRows[0])
        setExpandedRows((prev) => (prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [id]));

    };

    const templateColumns: any = [
        {
            field: 'template_name',
            headerName: 'Template Name',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 200,
            width: '700px',
            renderCell: (params: any) => {
                return (
                    <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                    >
                        {params.value}
                    </Typography>
                );
            },
        },

        {
            field: 'created_date',
            headerName: 'Created Date',
            flex: 1,
            sortable: true,
            resizable: false,
            customFilterReq: true,
            headerAlign: 'left',
            align: 'left',
            minWidth: 200,
            width: '700px',
            renderCell: (params: any) => {
                return (
                    <Typography
                        component='p'
                        variant='subtitle1'
                        sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                    >
                        {/* {params.value} */}{dayjs.utc(params.value).local().format('MMM D, YYYY')}
                    </Typography>
                );
            },
        },
        {
            field: 'actions',
            headerName: 'ACTIONS',
            sortable: false,
            headerAlign: 'center',
            align: 'center',
            flex: 1,
            customFilterReq: false,
            minWidth: 90,
            width: '90px',
            renderCell: (params: any) => {
                const disbaleView = false;
                const disableUpdate = !hasAccessTo.update;
                const disableDelete = !hasAccessTo.delete;
                return (
                    <Box sx={{
                        display: 'flex',
                        gap: '16px', justifyContent: 'flex-end'
                    }}>
                        {tabState === 'templates' && <IconButton disableRipple sx={{ padding: 0 }} onClick={() => { handleMultipleActions('template_view', params.row) }} disabled={disbaleView}>
                            <ViewIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disbaleView ? 0.5 : 1,
                                }}
                            />
                        </IconButton>}
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => {
                            handleMultipleActions('template_edit', params.row)
                        }} disabled={disableUpdate}>
                            <CreateIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableUpdate ? 0.5 : 1,
                                }}
                            />
                        </IconButton>
                        <IconButton disableRipple sx={{ padding: 0 }} onClick={() => handleMultipleActions('template_delete', params.row)} disabled={disableDelete}>
                            <DeleteIcon
                                style={{
                                    cursor: 'pointer',
                                    width: 24,
                                    height: 24,
                                    opacity: disableDelete ? 0.5 : 1,
                                }}
                            />
                        </IconButton>
                    </Box>
                );
            },
        }
    ];

    return (
        <>
            <MasterComponent
                heading={
                    <Tabs value={tabState} onChange={onTabChange} TabIndicatorProps={{
                        style: {
                            backgroundColor: themeData.palette.primary.main,
                        },
                    }} >
                        <Tab label='Secrets' value={'secrets'} />
                        <Tab label='Templates' value={'templates'} />
                    </Tabs>
                }
                isFromSecrets
                isFromUseCase
                selectedTab={tabState}
                expandedRows={expandedRows}
                // onStatusChange={onStatusChange}
                isLoading={isSecretManagementDataLoading}
                // checkboxSelection
                onRowSelectionChange={handleRowSelection}
                rows={tabState === 'secrets' ? secretData : secretTemplateData}
                columns={tabState === 'secrets' ? secretColumns : templateColumns}
                isServerPagination
                totalRowCount={tabState === 'secrets' ? secretManagerDataTotalRowCount : secretTemplateDataTotalRowCount}
                pageNumber={tabState === 'secrets' ? secretManagerDataPageNumber : secretTemplateDataPageNumber}
                loadCustomTable={true}
                onPagination={(pageSize: number, pageNumber: number) => {
                    dispatchSecretListRequest({
                        limit: pageSize,
                        page: pageNumber
                    });
                }}
                isExpandable={tabState === 'secrets'}

                onSorting={({ field, sort }: { field: string; sort: string }) => {
                    if (tabState === 'secrets') {
                        let getFieldName: SecretFieldNameTypes = {
                            secret_name: 'secret_name',
                            template_id: 'template_id',
                            created_date: 'created_date'
                        };
                        const sortModel = { field: getFieldName[field as keyof SecretFieldNameTypes], sort };
                        dispatchSecretListRequest({
                            limit: DEFAULT_PAGE_SIZE,
                            page: secretManagerDataPageNumber,
                            ...sortModel,
                        });
                        setSortingModel(sortModel);
                    } else {
                        let getTempFieldName: TemplateFieldNameTypes = {
                            template_name: 'template_name',
                            created_date: 'created_date'
                        };
                        const sortModel = { field: getTempFieldName[field as keyof TemplateFieldNameTypes], sort };
                        dispatchSecretListRequest({
                            limit: DEFAULT_PAGE_SIZE,
                            page: secretTemplateDataPageNumber,
                            ...sortModel,
                        });
                        setSortingModel(sortModel);
                    }
                }}

                setTemplateModal={onTemplateModalOpen}
                setSecretModal={onSecretModalOpen}
                disableRowSelectionOnClick
                // selectionModel={selectedRows}
                // isRowSelectable={isRowSelectable}
                otherProps={{
                    getRowId: (row: any) => row.factory_id,
                }}
                noRowsOverlay={() => (
                    <Stack height='100%' alignItems='center' justifyContent='center'>
                        Data not available
                    </Stack>
                )}
                actionsColumn={{
                    // edit: {
                    //     // onClick: (params: GridValueGetterParams) => handleEdit(params.row),
                    // },
                    // delete: {
                    //     // onClick: (params: GridValueGetterParams) => {
                    //     //   setDeletableFactory(get(params, 'row', {}));
                    //     //   setAlertPopup({ isOpen: true, type: 'delete' });
                    //     // },
                    // },
                }}
                showSearch
                searchPlaceholder={'Search'}
                onSearch={(searchValue: string) => {
                    dispatchSecretListRequest({
                        limit: DEFAULT_PAGE_SIZE,
                        page: DEFAULT_PAGE_NUMBER,
                        search_item: searchValue,
                    });
                    //   dispatch(factoryManagementActions.onSearchForItem(searchValue));
                }}
            />
            <PopUp
                open={confirmPopup}
                icon={<AlertIcon color={palette.warning.main} />}
                message={`Are you sure to delete this ${deleteSelection}?`}
                cancel={true}
                confirmation={true}
                cancelLabel='No'
                confirmLabel='Yes'
                onConfirm={() => handleActions({}, 'confirm')}
                onClose={() => handleActions({}, 'warning')}
                onCancel={() => handleActions({}, 'warning')}
            />

            {templateModal && renderTemplateFormModal()}
            {secretModal && renderSecretsFormModal()}

        </>
    );
};

const mapStateToProps = (state: any) => ({
    secretsData: state.secretsManager.secretsData,
    isSecretManagementDataLoading: state.secretsManager.isSecretManagementDataLoading,
    isAddSecretSuccess: state.secretsManager.isAddSecretSuccess,
    isDeleteSecretSuccess: state.secretsManager.isDeleteSecretSuccess,
    templateData: state.secretsManager.templateData,
    isAddTemplateSuccess: state.secretsManager.isAddTemplateSuccess,
    isUpdateTemplateSuccess: state.secretsManager.isUpdateTemplateSuccess,
    isDeleteTemplateSuccess: state.secretsManager.isDeleteTemplateSuccess,
    secretManagerDataPageNumber: state.secretsManager.secretManagerDataPageNumber,
    secretManagerDataTotalRowCount: state.secretsManager.secretManagerDataTotalRowCount,
    secretTemplateDataTotalRowCount: state.secretsManager.secretTemplateDataTotalRowCount,
    secretTemplateDataPageNumber: state.secretsManager.secretTemplateDataPageNumber,
    isUpdateSecretSuccess: state.secretsManager.isUpdateSecretSuccess,
    decryptedSecret: state.secretsManager.decryptedSecret,
    userAccess: state.profile.userAccess,
    isFetchingSecretById: state.secretsManager.isFetchingSecretById,
});

export default connect(mapStateToProps)(SecretManger);
